// Where a kiosk stands. Every kiosk lists the kiosks in its "Байршил" window, so a
// customer at one can find another: under the kiosk's location, with where in the
// building it is, its hours, and a QR of its coordinates that opens Google Maps. The
// admin sets these in the kiosk's edit form and switches on the kiosks to list. The
// same rules as the cloud's utils/locations.js.

export const ADDRESS_MAX = 120;
export const HOURS_MAX = 120;

// The API leaves out the place of a printer that has none
export const placeOf = (printer) => printer.place || {};

// Whether the kiosks list the printer: switched on, and with a name to be listed under
export const isListed = (printer) =>
  placeOf(printer).listed === true && Boolean((printer.location || "").trim());

// The two coordinates in one field, "47.9226866, 106.9205694", as Google Maps copies
// them, or "" without them
export const pinText = (printer) => {
  const { lat, lng } = placeOf(printer);
  return typeof lat === "number" && typeof lng === "number"
    ? lat + ", " + lng
    : "";
};

// { lat, lng } of a coordinates field, both null when it is empty, or undefined when
// it cannot be read
export const pinOf = (text) => {
  const trimmed = text.trim();
  if (!trimmed) return { lat: null, lng: null };
  const match = /^(-?\d+(?:\.\d+)?)\s*[,\s]\s*(-?\d+(?:\.\d+)?)$/.exec(trimmed);
  if (!match) return undefined;
  const lat = Number(match[1]);
  const lng = Number(match[2]);
  return Math.abs(lat) <= 90 && Math.abs(lng) <= 180 ? { lat, lng } : undefined;
};

// What the kiosk's QR opens, for checking the pin
export const mapUrl = ({ lat, lng }) =>
  `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
